export const ABOUT_TESTIMONIALS_CONTENT = {
  eyebrow: 'STUDENT STORIES',
  title: 'Lives Transformed',
  highlight: 'Through the Quran',
  description:
    'Hear directly from our students and their families about their journey with us.',
}

export const ABOUT_TESTIMONIALS = [
  {
    quote:
      'Enrolling my daughter was the best decision I made. Within 3 months she was reciting Surah Al-Baqarah with perfect Tajweed. The teacher is so patient and the progress reports give me full visibility.',
    name: 'Amina Khalid',
    location: 'London, UK',
    flag: '🇬🇧',
    role: 'Parent',
    rating: 5,
    initials: 'AK',
  },
  {
    quote:
      "I'm a busy professional and couldn't commit to fixed schedules. The flexibility here is unmatched — I book sessions on my own terms and my teacher is always prepared and professional.",
    name: 'Yusuf Mohammed',
    location: 'Dubai, UAE',
    flag: '🇦🇪',
    role: 'Adult Student',
    rating: 5,
    initials: 'YM',
  },
  {
    quote:
      "As a revert, I was nervous about learning Quran as an adult. My teacher made me feel completely at ease. I've now completed Noorani Qaida and started reading the Quran independently — something I never imagined.",
    name: 'Sarah Johnson',
    location: 'Toronto, Canada',
    flag: '🇨🇦',
    role: 'Adult Learner',
    rating: 5,
    initials: 'SJ',
  },
  {
    quote:
      'My son had tried two other platforms before this one. The difference is night and day. The teacher tracks every mistake, gives weekly feedback, and my son genuinely enjoys every session.',
    name: 'Ibrahim Al-Hassan',
    location: 'Sydney, Australia',
    flag: '🇦🇺',
    role: 'Parent',
    rating: 5,
    initials: 'IA',
  },
  {
    quote:
      'I completed my Ijazah in Hafs recitation through this platform. The teachers are true scholars and the process was rigorous and spiritually fulfilling. I highly recommend it for serious students.',
    name: 'Fatima Benali',
    location: 'Paris, France',
    flag: '🇫🇷',
    role: 'Advanced Student',
    rating: 5,
    initials: 'FB',
  },
  {
    quote:
      'My three children all learn here now. The platform is well organized, the female tutors are wonderful, and the kids actually look forward to their Quran classes every week.',
    name: 'Maryam Qasim',
    location: 'Houston, USA',
    flag: '🇺🇸',
    role: 'Parent of 3',
    rating: 5,
    initials: 'MQ',
  },
]
